import { Pipe, PipeTransform } from '@angular/core';

type ScoreCardItem = Record<string, string | undefined>;

@Pipe({
  name: 'jobName',
  standalone: false,
})
export class ScoreCardJobNamePipe implements PipeTransform {
  transform(
    items: ScoreCardItem[],
    fieldToCompare: string,
    fieldToReturn: string,
    value: string
  ): string {
    const item = items.find((x) => x[fieldToCompare] === value);
    return item ? item[fieldToReturn] : '';
  }
}
